import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Image from "./Image";

const Video = ({ url, muted, placeholder, play, loop }) => {
  // react-player only runs in the browser — render the placeholder on the
  // server and swap the player in after mount so hydration matches
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !url || !ReactPlayer.canPlay(url)) {
    return (
      <div>
        <Image {...placeholder} />
      </div>
    );
  }

  return (
    <div className="videoEmbed">
      <ReactPlayer
        className="absolute top-0 left-0"
        url={url}
        playing={play}
        muted={muted}
        loop={loop}
        controls
        width="100%"
        height="100%"
        playsInline
      />
    </div>
  );
};

Video.defaultProps = {
  play: true,
};

export default Video;
